var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"formBox-contain-group"},[_c('div',{staticClass:"labeltxts"},[_c('div',[(_vm.required)?_c('span',{staticClass:"start"},[_vm._v("*")]):_vm._e(),_vm._v(_vm._s(_vm.labeltxt ? `${_vm.labeltxt}：` : '')+" ")]),_vm._t("labeltxt")],2),_c('div',{staticClass:"contents"},[_vm._t("default")],2),_c('div',[_vm._t("noContents")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }